import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./pipelines/event_hub.js